module.exports = __webpack_public_path__ + "static/hybrid_flier-cb54ff31b7fd8ef6b74f5ee698fb01c3.png";